'use client'

import { useEffect, useRef } from 'react'
import { useTrackFormStepViewed } from '@nwwp/segment-analytics'
import { ALL_TRACKING_PARAMETERS } from '@nwwp/utils'
import { useFunnelStore } from '../../_hooks/use-funnel-store'

const allowedTrackingKeys: readonly string[] = ALL_TRACKING_PARAMETERS

export const FormStepViewed = ({
  children,
  step,
  type,
  enabled = true,
}: {
  children: React.ReactNode
  step: string
  type: string
  enabled?: boolean
}) => {
  const trackFormStepViewed = useTrackFormStepViewed()
  const emitted = useRef(false)

  useEffect(() => {
    if (!enabled) return
    if (emitted.current) return

    emitted.current = true
    const tracking = useFunnelStore.getState().tracking
    const filteredTracking = Object.fromEntries(
      Object.entries(tracking).filter(([key]) => allowedTrackingKeys.includes(key))
    )

    trackFormStepViewed({ step, type, formName: 'find-your-advisor', ...filteredTracking })
  }, [trackFormStepViewed, step, type, enabled])

  return children
}
